import React from 'react';
import Footer from 'components/Footer';

import Header from './Header';
import SignUpDisabled from './SignUpDisabled';
import './styles.scss';

const SignUp = () => (
  <main className="sign-up-page">
    <Header width={129} height={32} />
    <SignUpDisabled />
    <Footer isRiskDisclosureHidden />
  </main>
);

export default SignUp;



// WEBPACK FOOTER //
// ../src/components/SignUp/index.jsx